import { WorkItemIntegration } from './models/work-item-integrations.model';
import { journeyIntegration } from './models/journey-integration.constant';
import { externalContactIntegration } from './models/external-contact-integration.constant';
import { smartAdvisorIntegration } from './models/smart-advisor/smart-advisor-integration.constant';

export interface GenesysCloudWorkItemIntegrationsState {
  integrations: WorkItemIntegration[];
  openIntegrationPanels: {
    [conversationId: string]: WorkItemIntegration[];
  }
}

export const initialState = (): GenesysCloudWorkItemIntegrationsState => ({
  integrations: [
    smartAdvisorIntegration,
    journeyIntegration,
    externalContactIntegration
  ],
  openIntegrationPanels: {}
});
